import "./App.css";

export function GetSpreadSheetID(URL: String) {
  const words = URL.split("/");
  console.log(words);
  for (let index = 0; index < words.length; index++) {
    const element = words[index];
    if (element === `d`) {
      return words[index + 1];
    }
  }
  return "";
}
